import * as React from "react";

interface CrossfitTableSidebarRowProps {
    children: React.ReactNode | readonly React.ReactNode[];
}

export function CrossfitTableSidebarRow(props: CrossfitTableSidebarRowProps): JSX.Element {
    return <tr>{props.children}</tr>;
}
